<div
  mat-dialog-title
  class="d-flex justify-content-start align-items-center"
  style="margin: 0; padding: 24px 24px 0 24px"
>
  @if (values.icon) {
  <mat-icon style="margin-right: 12px; margin-left: -5px">{{
    values.icon
  }}</mat-icon>
  }

  <span style="font-size: large; font-weight: 500; margin: 0; padding: 0">
    {{ 'shared.confirmation-popup.title' | translate }}
  </span>
</div>

<mat-dialog-content
  class="mat-typography"
  style="margin: 0; overflow: hidden; padding: 16px 24px 0 24px !important"
>
  <div
    style="
      font-size: 14px !important;
      color: #000000de !important;
      margin-bottom: 16px;
    "
  >
    {{ data?.description || '' }}
  </div>

  <h6 style="margin: 0; font-size: 14px; font-weight: 500; color: #000000de">
    {{ 'shared.confirmation-popup.proceed' | translate }}
  </h6>

  @if (data.need_authentication) {
  <div
    class="mt-3"
    style="font-size: 14px !important; color: #000000de !important"
  >
    {{ 'shared.confirmation-popup.auth-confirm' | translate }}
  </div>
  <form [formGroup]="authentication">
    <mat-form-field
      color="primary"
      class="mt-3"
      style="width: 100%"
      appearance="fill"
    >
      <mat-label>{{
        'shared.confirmation-popup.password' | translate
      }}</mat-label>
      <input
        data-testid="confirmation_popup_input_password"
        #password
        id="password"
        type="password"
        [type]="hide ? 'password' : 'text'"
        matInput
        [placeholder]="'shared.confirmation-popup.placeholder-pwd' | translate"
        formControlName="password"
        required
        ng-model="password"
        autocomplete="off"
        readonly
        (focus)="password.readOnly = false"
        (blur)="password.readOnly = true"
      />
      @if (hide) {
      <button
        data-testid="confirmation_popup_btn_show_password"
        type="button"
        mat-icon-button
        matSuffix
        (click)="hide = !hide"
        matTooltip="{{ 'shared.confirmation-popup.pwd-hidden' | translate }}"
      >
        <mat-icon style="font-size: 20px !important; margin-top: 4px !important"
          >visibility_off</mat-icon
        >
      </button>
      } @if (!hide) {
      <button
        data-testid="confirmation_popup_btn_hide_password"
        type="button"
        mat-icon-button
        matSuffix
        (click)="hide = !hide"
        matTooltip="{{ 'shared.confirmation-popup.pwd-visible' | translate }}"
      >
        <mat-icon>visibility</mat-icon>
      </button>
      } @if (authentication.controls.password.hasError('required')) {
      <mat-error>
        <p>
          {{
            'shared.confirmation-popup.validation.password-required' | translate
          }}
        </p>
      </mat-error>
      } @if (authentication.controls.password.hasError('incorrect')) {
      <mat-error>
        <p>
          {{
            'shared.confirmation-popup.validation.password-invalid' | translate
          }}
        </p>
      </mat-error>
      }
    </mat-form-field>
  </form>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" style="padding: 16px 24px">
  <button
    data-testid="confirmation_popup_btn_proceed_option_no"
    mat-button
    [mat-dialog-close]="false"
    matTooltip="{{ 'shared.confirmation-popup.no' | translate }}"
  >
    {{ 'shared.common.no' | translate }}
  </button>
  <button
    data-testid="confirmation_popup_btn_proceed_option_yes"
    mat-raised-button
    [color]="values.color"
    [disabled]="
      data.need_authentication &&
      (authentication.controls.password.invalid ||
        authentication.controls.password.pristine)
    "
    (click)="onClickYes()"
    cdkFocusInitial
    matTooltip="{{ 'shared.confirmation-popup.yes' | translate }}"
  >
    {{ 'shared.common.yes' | translate }}
  </button>
</mat-dialog-actions>
